'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import AdAccountPermissionsRecord from 'AdsUI/records/ad-accounts/AdAccountPermissionsRecord';

const AdAccountsPermissionsReducer = (state = ImmutableMap(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.AD_ACCOUNTS_MY_PERMISSIONS_FETCH_SUCCEEDED:
      {
        return payload.reduce((permissionsMap, {
          adNetwork,
          adAccountId,
          permissions,
          hubSpotUserId,
          networkUserId
        }) => permissionsMap.setIn([adNetwork, adAccountId], new AdAccountPermissionsRecord(Object.assign({}, permissions, {
          hubSpotUserId,
          networkUserId,
          currentUserHasConnected: true
        }))), ImmutableMap());
      }

    default:
      {
        return state;
      }
  }
};

export default AdAccountsPermissionsReducer;